import { TriangleAlert } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@shared/components/ui/alert";

/**
 * Affiché quand une requête admin échoue — typiquement quand les migrations
 * de db/migrations/ n'ont pas encore été appliquées.
 */
export function AdminDataNotice({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : "Données indisponibles.";
  return (
    <Alert role="alert" variant="destructive">
      <TriangleAlert />
      <AlertTitle>Impossible de charger les données.</AlertTitle>
      <AlertDescription>
        <p>{message}</p>
        <p>
          Vérifiez que les migrations ont bien été appliquées à la base
          (<code className="font-mono">npm run db:migrate</code>).
        </p>
      </AlertDescription>
    </Alert>
  );
}
